import React from "react";
import "./Footer.css";
import MsaLogo from "./MsaLogo";

// Links específicos do menu
const navLinks = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Planos",
    href: "/planos",
  },
  {
    label: "Contato",
    href: "/contatos",
  },
  {
    label: "2ª Via da Fatura",
    href: "/2via",
  },
];

const CENTRAL_ASSINANTE_URL = "https://ixc.faynetrj.com.br/central_assinante_web/login";

function Footer() {
  return (
    <footer className="footer">
      {/* PARTE PRINCIPAL DO FOOTER */}
      <div className="footer__top">
        <div className="footer__container">

          {/* LOGO / MARCA */}
          <div className="footer__brand">
            <div className="footer__logo">
              <MsaLogo />
            </div>

            <p className="footer__tagline">
              Internet rápida, estável e de alta qualidade para você e sua família,
              com atendimento próximo e de verdade.
            </p>

            <div className="footer__brand-line" />

            <div className="footer__address">
              <span className="footer__address-label">Endereço</span>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Estrada+da+Matriz,+1040,+Guaratiba,+Rio+de+Janeiro+-+RJ,+23020-715"
                target="_blank"
                rel="noreferrer"
                className="footer__address-link"
              >
                Estrada da Matriz, nº 1040<br />
                Guaratiba, Rio de Janeiro - RJ<br />
                CEP 23020-715
              </a>
            </div>
          </div>

          <div className="footer__divider" />

          {/* CONTATO */}
          <div className="footer__col footer__col--contact">
            <h4 className="footer__col-title">FALE CONOSCO</h4>

            <ul className="footer__contact-list">
              {/* TELEFONE */}
              <li>
                <span className="footer__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.04 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </span>

                <a
                  href="tel:+552134018348"
                  className="footer__contact-link"
                >
                  (21) 3401-8348
                </a>
              </li>

              {/* WHATSAPP */}
              <li>
                <span className="footer__icon footer__icon--whatsapp">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                </span>

                <a
                  href="https://api.whatsapp.com/send?phone=5521987940668&text=Vim%20do%20site%20da%20Faynet%20e%20quero%20saber%20mais%20sobre%20os%20planos!"
                  target="_blank"
                  rel="noreferrer"
                  className="footer__contact-link"
                >
                  (21) 98794-0668
                </a>
              </li>

              {/* E-MAIL */}
              <li>
                <span className="footer__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="2"
                      y="4"
                      width="20"
                      height="16"
                      rx="2"
                    />
                    <path d="M2 7l10 7 10-7" />
                  </svg>
                </span>

                <a
                  href="mailto:contato@faynetrj.com.br"
                  className="footer__contact-link"
                >
                  contato@faynetrj.com.br
                </a>
              </li>
            </ul>

            <p className="footer__work-title">Trabalhe conosco</p>
            <a
              href="mailto:trabalheconosco@faynetrj.com.br"
              className="footer__contact-link"
            >
              trabalheconosco@faynetrj.com.br
            </a>
          </div>

          <div className="footer__divider" />

          {/* LINKS RÁPIDOS */}
          <div className="footer__col footer__col--links">
            <h4 className="footer__col-title">LINKS RAPIDOS</h4>

            <ul className="footer__links">
              {navLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="footer__nav-link"
                  >
                    <span className="footer__arrow">
                      &#8250;
                    </span>

                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__divider" />

          {/* CENTRAL DO ASSINANTE + REDES SOCIAIS */}
          <div className="footer__col footer__col--social">
            <h4 className="footer__col-title">CENTRAL DO ASSINANTE</h4>

            <a
              href={CENTRAL_ASSINANTE_URL}
              target="_blank"
              rel="noreferrer"
              className="footer__central-link"
            >
              Acessar Central do Assinante
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=br.com.faynetrj.centraldoassinante&hl=pt_BR"
              target="_blank"
              rel="noreferrer"
              className="footer__playstore-btn"
            >
              <img
                src="/index/badge_playstore.svg"
                alt="Disponível no Google Play"
                className="footer__playstore-badge"
              />
            </a>

            <h4 className="footer__col-title footer__col-title--spaced">SIGA-NOS</h4>

            <div className="footer__social">

              {/* FACEBOOK */}
              <a
                href="https://www.facebook.com/faynetrj"
                target="_blank"
                rel="noreferrer"
                className="footer__social-btn"
                aria-label="Facebook"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="18"
                  height="18"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                </svg>
              </a>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/faynet_rj"
                target="_blank"
                rel="noreferrer"
                className="footer__social-btn"
                aria-label="Instagram"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="18"
                  height="18"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                  />
                  <circle cx="12" cy="12" r="4" />
                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>

            </div>
          </div>

        </div>
      </div>

      {/* HORÁRIOS DE ATENDIMENTO */}
      <div className="footer__horarios">
        <div className="footer__horarios-container">
          <p className="footer__horario-item">
            <strong>Atendimento - Loja:</strong> Segunda à Sexta de 9:00h às 18:00h · Sábado de 9:00h às 13:00h
          </p>

          <span className="footer__horario-sep" />

          <p className="footer__horario-item">
            <strong>Central de Atendimento - SAC:</strong> Segunda à Domingo de 08:30h às 20:50h
          </p>
        </div>
      </div>

      {/* RODAPÉ INFERIOR */}
      <div className="footer__bottom">
        <div className="footer__accent-line" />

        <div className="footer__bottom-content">
          <p className="footer__company">FAY NET LTDA · CNPJ: 49.871.308/0001-00</p>
          <p className="footer__copy">
            &#169; 2026 Faynet. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;